var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center min-h-screen"},[(_vm.isLoading)?_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"}),_c('p',{staticClass:"mt-4 text-gray-600"},[_vm._v("Processing login...")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }